<div style="position: relative; height:100%; width:100%;" class="d-flex flex-column justify-content-center align-items-center">
  <canvas #chartCanvas></canvas>
</div>
